export default function Portfolio() {
  const portfolioItems = [
    {
      id: 1,
      title: "Residencial Alto Padrão",
      description: "Empreendimento residencial com acabamentos de luxo e localização privilegiada",
      image: "https://public.readdy.ai/ai/img_res/10d41b3b2fff70e6c7de2782c1b40541.jpg",
      category: "Residencial"
    },
    {
      id: 2,
      title: "Condomínio Fechado Premium",
      description: "Desenvolvimento de condomínio com infraestrutura completa e área de lazer",
      image: "https://readdy.ai/api/search-image?query=Luxury%20gated%20community%20with%20modern%20houses%2C%20swimming%20pool%2C%20landscaped%20gardens%2C%20security%20gate%2C%20premium%20residential%20development%2C%20professional%20architectural%20photography%2C%20clean%20background%2C%20high-quality%20construction&width=600&height=400&seq=portfolio2&orientation=landscape",
      category: "Condomínio"
    },
    {
      id: 3,
      title: "Apartamentos de Luxo",
      description: "Torre residencial com vista panorâmica e acabamentos sofisticados",
      image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20apartment%20building%2C%20modern%20glass%20tower%2C%20panoramic%20city%20views%2C%20sophisticated%20architecture%2C%20upscale%20residential%20construction%2C%20professional%20real%20estate%20photography%2C%20clean%20minimalist%20background&width=600&height=400&seq=portfolio3&orientation=landscape",
      category: "Apartamentos"
    },
    {
      id: 4,
      title: "Casa de Alto Padrão",
      description: "Residência exclusiva com design contemporâneo e tecnologia integrada",
      image: "https://readdy.ai/api/search-image?query=Contemporary%20luxury%20house%20with%20modern%20design%2C%20large%20windows%2C%20beautiful%20landscaping%2C%20high-end%20residential%20architecture%2C%20premium%20construction%20quality%2C%20professional%20photography%2C%20clean%20background&width=600&height=400&seq=portfolio4&orientation=landscape",
      category: "Residencial"
    },
    {
      id: 5,
      title: "Empreendimento Comercial",
      description: "Desenvolvimento de espaços comerciais modernos e funcionais",
      image: "https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20with%20glass%20facades%2C%20contemporary%20office%20architecture%2C%20professional%20business%20development%2C%20high-quality%20construction%2C%20clean%20urban%20setting%2C%20architectural%20photography&width=600&height=400&seq=portfolio5&orientation=landscape",
      category: "Comercial"
    },
    {
      id: 6,
      title: "Projeto Sustentável",
      description: "Construção eco-friendly com certificação ambiental e eficiência energética",
      image: "https://readdy.ai/api/search-image?query=Sustainable%20green%20building%20with%20solar%20panels%2C%20eco-friendly%20architecture%2C%20modern%20environmental%20design%2C%20LEED%20certified%20construction%2C%20professional%20architectural%20photography%2C%20clean%20background&width=600&height=400&seq=portfolio6&orientation=landscape",
      category: "Sustentável"
    }
  ];

  const handleWhatsAppContact = () => {
    const phoneNumber = "5532991439367";
    const message = "Olá! Gostaria de saber mais sobre os empreendimentos da Gleimatus.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="portfolio" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nosso Portfólio
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Conheça alguns dos nossos principais empreendimentos que demonstram nossa excelência 
            em construção civil e incorporação imobiliária
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {portfolioItems.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {item.category}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-amber-600 to-amber-500 rounded-3xl p-12 text-center text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Interessado em nossos empreendimentos?
            </h3>
            <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
              Entre em contato conosco pelo WhatsApp e descubra como podemos realizar seu próximo projeto
            </p>
            
            <button
              onClick={handleWhatsAppContact}
              className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-2xl hover:shadow-green-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Falar no WhatsApp
            </button>

            <div className="mt-8 flex items-center justify-center gap-8 text-white/80">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-xl"></i>
                <span>Resposta Rápida</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-xl"></i>
                <span>Atendimento Personalizado</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-xl"></i>
                <span>Consultoria Gratuita</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}